import { Dialog, DialogBody, DialogTitle } from "V2.0/common/dialog";
import WhatsappTriggerForm from "./WhatsappTriggerForm";

export default function WhatsappTriggerEdit({
  whatsappTrigger,
  open,
  onClose,
  onTriggerEdit,
  assistants,
  whatsappTemplates,
  whatsappConfiguration,
  mcubeEngageTemplates,
  mcubeEngageConfiguration,
}) {
  return (
    <Dialog
      className=""
      size="xl"
      open={open}
      onClose={onClose}
    >
      <DialogTitle>
        <p className="text-lg">Edit WhatsApp Trigger</p>
      </DialogTitle>
      <DialogBody className="text-sm/6">
        <WhatsappTriggerForm
          whatsappTrigger={whatsappTrigger}
          onCancel={onClose}
          onSubmit={onTriggerEdit}
          assistants={assistants}
          whatsappTemplates={whatsappTemplates}
          whatsappConfiguration={whatsappConfiguration}
          mcubeEngageTemplates={mcubeEngageTemplates}
          mcubeEngageConfiguration={mcubeEngageConfiguration}
        />
      </DialogBody>
    </Dialog>
  );
}
